module.exports = {"register":"https://app.entreinaweb.com/cadastrar","login":"https://app.entreinaweb.com/login","redfoot":"http://www.redfootbrasil.org/"}